exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td .workflow-text-input-cell .ant-form-item-control {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n}\ntd .workflow-text-input-cell .ant-form-item-control .ant-form-item-control-input {\n  flex: 1 1;\n}\ntd .workflow-text-input-cell .ant-form-item-control .ant-form-item-extra {\n  flex: 0 0;\n}\n", ""]);

// exports
